export default [
  {
    path: '/pre-invoices',
    name: 'pre-invoice',
    meta: { requiresAuth: true },
    redirect: to => ({
      name: 'pre-invoice-v2',
      query: to.query,
      hash: to.hash
    })
  },
  {
    path: '/pre-invoices/create',
    name: 'pre-invoice-create',
    meta: { requiresAuth: true },
    redirect: to => ({
      name: 'pre-invoice-v2-create',
      query: to.query,
      hash: to.hash
    })
  },
  {
    path: '/pre-invoices/:id/show',
    name: 'pre-invoice-show',
    meta: { requiresAuth: true },
    redirect: to => ({
      name: 'pre-invoice-v2-edit',
      params: { id: to.params.id },
      query: to.query,
      hash: to.hash
    })
  },
  {
    path: '/pre-invoices/:id',
    name: 'pre-invoice-edit',
    meta: { requiresAuth: true },
    redirect: to => ({
      name: 'pre-invoice-v2-edit',
      params: { id: to.params.id },
      query: to.query,
      hash: to.hash
    })
  }
]
